const SET_APP_LOADING: string = "SET_APP_LOADING";
const SET_COUNTRY_OPTIONS: string = "SET_COUNTRY_OPTIONS";
const SET_ACCOUNTID_VALUE: string = "SET_ACCOUNTID_VALUE";
const SET_USERACCOUNT_VALUE: string = "SET_USERACCOUNT_VALUE";
const SET_IP_DATA: string = "SET_IP_DATA";
const UPDATE_BASIC_DATA_ITEM: string = "UPDATE_BASIC_DATA_ITEM";
const UPDATE_RETAIL_DATA: string = "UPDATE_RETAIL_DATA";
const UPDATE_RETAIL_DATA_ITEM: string = "UPDATE_RETAIL_DATA_ITEM";
const UPDATE_COMMERCIAL_DATA_ITEM: string = "UPDATE_COMMERCIAL_DATA_ITEM";
const UPDATE_BANKINFO_DATA: string = "UPDATE_BANKINFO_DATA";
const UPDATE_BANKINFO_DATA_ITEM: string = "UPDATE_BANKINFO_DATA_ITEM";
const UPDATE_WALLETINFO_DATA: string = "UPDATE_WALLETINFO_DATA";
const UPDATE_WALLETINFO_DATA_ITEM: string = "UPDATE_WALLETINFO_DATA_ITEM";
const SET_CURRENCY_OPTIONS: string = "SET_CURRENCY_OPTIONS";

const initState = {
  isAppLoading: false,
  countriesOptions: [],
  currenciesOptions: [],
  accountIdValue: "",
  error: null,
  ipData: {
    IPAddress: "",
    Country: "",
    IsoCode: "",
    CountryCode: "",
    Region: "",
    City: "",
  },
  basicData: {
    AccountType: "",
    Currency: "",
    ResidenceCountry: "",
  },
  retailData: {
    PhoneCountryCode: "",
    EmploymentStatusData: {},
    SourceFundsData: {},
  },
  commercialData: {
    UsersCount: "0",
    EntityCount: "0",
    UserForm: [],
    EntityForm: [],
    PhoneCountryCode: "",
  },
  bankInfoData: {
    //AccountId: ""
  },
  walletInfoData: {
    AccountId: "",
    WalletDetails: [],
  },
};

const appReducer = (state = initState, action) => {
  var action_type = action.type;

  if (action_type === SET_APP_LOADING) {
    return { ...state, isAppLoading: action.state };
  }

  if (action_type === SET_COUNTRY_OPTIONS) {
    return { ...state, countriesOptions: action.state };
  }

  if (action_type === SET_CURRENCY_OPTIONS) {
    return { ...state, currenciesOptions: action.state };
  }

  if (action_type === SET_ACCOUNTID_VALUE) {
    return { ...state, accountIdValue: action.state };
  }

  if (action_type === SET_USERACCOUNT_VALUE) {
    return { ...state, userAccountValue: action.state };
  }

  if (action_type === SET_IP_DATA) {
    return { ...state, ipData: action.state };
  }

  if (action_type === UPDATE_BASIC_DATA_ITEM) {
    let { basicData } = state;
    let _basicData = { ...basicData, ...action.state };

    return { ...state, basicData: _basicData };
  }

  if (action_type === UPDATE_RETAIL_DATA) {
    return { ...state, retailData: action.state };
  }

  if (action_type === UPDATE_RETAIL_DATA_ITEM) {
    let { retailData } = state;
    let _retailData = { ...retailData, ...action.state };

    return { ...state, retailData: _retailData };
  }

  if (action_type === UPDATE_COMMERCIAL_DATA_ITEM) {
    let { commercialData } = state;
    let _commercialData = { ...commercialData, ...action.state };
    return { ...state, commercialData: _commercialData };
  }

  if (action_type === UPDATE_BANKINFO_DATA) {
    return { ...state, bankInfoData: action.state };
  }

  if (action_type === UPDATE_BANKINFO_DATA_ITEM) {
    let { bankInfoData } = state;
    let _bankInfoData = { ...bankInfoData, ...action.state };
    return { ...state, bankInfoData: _bankInfoData };
  }

  if (action_type === UPDATE_WALLETINFO_DATA) {
    return { ...state, walletInfoData: action.state };
  }

  if (action_type === UPDATE_WALLETINFO_DATA_ITEM) {
    let { walletInfoData } = state;
    let _walletInfoData = { ...walletInfoData, ...action.state };
    return { ...state, walletInfoData: _walletInfoData };
  }

  return state;
};

export const setAppLoading = (state) => ({
  type: SET_APP_LOADING,
  state: state,
});

export const setCountryOptions = (state) => ({
  type: SET_COUNTRY_OPTIONS,
  state: state,
});

export const setCurrencyOptions = (state) => ({
  type: SET_CURRENCY_OPTIONS,
  state: state,
});

export const setAccountIdValue = (state) => ({
  type: SET_ACCOUNTID_VALUE,
  state: state,
});

export const setUserAccountValue = (state) => ({
  type: SET_USERACCOUNT_VALUE,
  state: state,
});

export const setIpData = (state) => ({
  type: SET_IP_DATA,
  state: state,
});

export const updateBasicDataItem = (state) => ({
  type: UPDATE_BASIC_DATA_ITEM,
  state: state,
});

export const updateRetailData = (state) => ({
  type: UPDATE_RETAIL_DATA,
  state: state,
});

export const updateRetailDataItem = (state) => ({
  type: UPDATE_RETAIL_DATA_ITEM,
  state: state,
});

export const updateCommercialDataItem = (state) => ({
  type: UPDATE_COMMERCIAL_DATA_ITEM,
  state: state,
});

export const updateBankInfoData = (state) => ({
  type: UPDATE_BANKINFO_DATA,
  state: state,
});

export const updateBankInfoDataItem = (state) => ({
  type: UPDATE_BANKINFO_DATA_ITEM,
  state: state,
});

export const updatwalletInfoData = (state) => ({
  type: UPDATE_WALLETINFO_DATA,
  state: state,
});

export const updatwalletInfoDataItem = (state) => ({
  type: UPDATE_WALLETINFO_DATA_ITEM,
  state: state,
});

export default appReducer;

export { initState };
